import { useState } from "react";
import axios from "axios";
import SuccessCard from "./SuccessCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LeadForm({ idPrefix = "form", dark = false }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", instagram: "", referrer: "", message: "", consent: false });
  const [status, setStatus] = useState("idle");

  const set = (key) => (e) =>
    setForm({ ...form, [key]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      await axios.post(`${API}/register`, form);
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };

  const inputCls = dark
    ? "w-full rounded-xl bg-[#FFFFFF]/10 border border-[#A89DE3]/30 px-4 py-3.5 text-[#FFFFFF] placeholder-[#A89DE3] focus:outline-none focus:border-[#1B2FD8] transition-colors"
    : "w-full rounded-xl bg-white border border-[#E3E3F0] px-4 py-3.5 text-[#0F0F1A] placeholder-[#9A97B5] focus:outline-none focus:border-[#1B2FD8] transition-colors";
  const labelCls = dark ? "text-[#D9D6EC]" : "text-[#4A4A66]";

  if (status === "success") {
    return <SuccessCard idPrefix={idPrefix} dark={dark} labelCls={labelCls} />;
  }

  return (
    <form data-testid={`${idPrefix}-container`} onSubmit={submit} className="space-y-4">
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className={`block text-xs font-semibold uppercase tracking-[0.15em] mb-2 ${labelCls}`}>Name*</label>
          <input data-testid={`${idPrefix}-name-input`} required value={form.name} onChange={set("name")} placeholder="Your name" className={inputCls} />
        </div>
        <div>
          <label className={`block text-xs font-semibold uppercase tracking-[0.15em] mb-2 ${labelCls}`}>Email address*</label>
          <input data-testid={`${idPrefix}-email-input`} type="email" required value={form.email} onChange={set("email")} placeholder="you@email.com" className={inputCls} />
        </div>
      </div>
      <div>
        <label className={`block text-xs font-semibold uppercase tracking-[0.15em] mb-2 ${labelCls}`}>
          Cell Phone Number* <span className="normal-case font-normal">(you'll receive the invitation to my app via text)</span>
        </label>
        <input data-testid={`${idPrefix}-phone-input`} type="tel" required value={form.phone} onChange={set("phone")} placeholder="(555) 555-5555" className={inputCls} />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className={`block text-xs font-semibold uppercase tracking-[0.15em] mb-2 ${labelCls}`}>Instagram Handle</label>
          <input data-testid={`${idPrefix}-instagram-input`} value={form.instagram} onChange={set("instagram")} placeholder="@yourhandle" className={inputCls} />
        </div>
        <div>
          <label className={`block text-xs font-semibold uppercase tracking-[0.15em] mb-2 ${labelCls}`}>Who referred you?</label>
          <input data-testid={`${idPrefix}-referrer-input`} value={form.referrer} onChange={set("referrer")} placeholder="Friend, coach, Instagram…" className={inputCls} />
        </div>
      </div>
      <div>
        <label className={`block text-xs font-semibold uppercase tracking-[0.15em] mb-2 ${labelCls}`}>Message</label>
        <textarea data-testid={`${idPrefix}-message-input`} rows={3} value={form.message} onChange={set("message")} placeholder="Anything I should know?" className={inputCls} />
      </div>
      <label className={`flex items-start gap-3 text-sm leading-relaxed cursor-pointer ${labelCls}`}>
        <input data-testid={`${idPrefix}-consent-checkbox`} type="checkbox" checked={form.consent} onChange={set("consent")} className="mt-1 accent-[#1B2FD8]" />
        Yes, I'd like to receive challenge updates, health/fitness education and occasional offers from HERcules Health by email. I can unsubscribe at any time.
      </label>
      {status === "error" && (
        <p data-testid={`${idPrefix}-error-message`} className="text-sm font-semibold text-[#1B2FD8]">
          Something went wrong sending your registration. Please try again.
        </p>
      )}
      <button
        data-testid={`${idPrefix}-submit-button`}
        type="submit"
        disabled={status === "sending"}
        className="w-full rounded-full bg-[#1B2FD8] text-[#FFFFFF] py-4 font-display font-extrabold tracking-wide text-lg hover:bg-[#0B0B12] disabled:opacity-60 transition-colors duration-300"
      >
        {status === "sending" ? "JOINING…" : "IM IN - Join FREE"}
      </button>
    </form>
  );
}
